import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "tab"]
  static values = { active: { type: String, default: "positions" } }

  switch(event) {
    this.activeValue = event.currentTarget.dataset.view
  }

  activeValueChanged(value) {
    this.panelTargets.forEach(el => el.classList.toggle("hidden", el.dataset.view !== value))
    this.tabTargets.forEach(el => {
      const isActive = el.dataset.view === value
      el.classList.toggle("text-gray-900", isActive)
      el.classList.toggle("border-teal-500", isActive)
      el.classList.toggle("text-gray-400", !isActive)
      el.classList.toggle("border-transparent", !isActive)
    })
  }
}
